import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";





























import { PrimaryContractor } from "../../../../timber/types/models/Contractor";

import ContractorFormSelect from "../../../../timber/components/contractor/ContractorForm/ContractorFormSelect";















import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";
















export const initialFormStateFn = () => { return {
    
        
        email: "",
        
    
        
        name: "",
        
    
        
        description: "",
        
    
        
        shipmentLogCode: "",
        
    
        
        shipmentLogCounter: "1",
        
    
        
        shipmentCordwoodCode: "",
        
    
        
        shipmentCordwoodCounter: "1",
        
    
        
        userType: UserType.Normal,
        
    
        
        contractorId: null,
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.contractorId = PrimaryContractor.fromQuery(location.state?.contractorId) || null;
    

    

    return React.useMemo(() => initialFormState, [
        location.state,
        
        
    ])
}

export const formObject = {
    
    
        email:
        string()
        .trim()
        .min(1, msg`Email is required`),
    
    
        name:
        string()
        .trim()
        .min(1, msg`Name is required`),
    
    
        description:
        string()
        .trim()
        .nullish(),
    
    
        shipmentLogCode:
        string()
        .trim()
        .min(1, msg`Shipment Log Code is required`),
    
    
        shipmentLogCounter:
        string()
        .trim()
        .min(1, msg`Shipment Log Counter is required`),
    
    
        shipmentCordwoodCode:
        string()
        .trim()
        .min(1, msg`Shipment Cordwood Code is required`),
    
    
        shipmentCordwoodCounter:
        string()
        .trim()
        .min(1, msg`Shipment Cordwood Counter is required`),
    
    
        userType:
        string()
        .trim()
        .min(1, msg`User Type is required`),
    
    
        contractorId:
        string()
                .nanoid(msg`Contractor is required`)
                .min(1, msg`Contractor is required`),
    
};

export const formSchema = object(formObject);

const ContractorUserAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'email' }
       aria-label="email"
       data-testid="email"
       label={t`Email`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'name' }
       aria-label="name"
       data-testid="name"
       label={t`Name`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'description' }
       aria-label="description"
       data-testid="description"
       label={t`Description`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'shipmentLogCode' }
       aria-label="shipmentLogCode"
       data-testid="shipmentLogCode"
       label={t`Shipment Log Code`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'shipmentLogCounter' }
       aria-label="shipmentLogCounter"
       data-testid="shipmentLogCounter"
       label={t`Shipment Log Counter`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'shipmentCordwoodCode' }
       aria-label="shipmentCordwoodCode"
       data-testid="shipmentCordwoodCode"
       label={t`Shipment Cordwood Code`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'shipmentCordwoodCounter' }
       aria-label="shipmentCordwoodCounter"
       data-testid="shipmentCordwoodCounter"
       label={t`Shipment Cordwood Counter`}
       
       type='text'
       
   />
   
   
           
           
   
    <crudgen.FormSelect
        required
        name={ prefix + 'userType' }
        aria-label="userType"
        label={t`User Type`}
        options={ UserTypePairs }
        optionLabelMap={ toStringUserType }
    />
   
   
           
           
   
    
    <ContractorFormSelect
        type="dynamicSelect"
        name="contractorId"
        label={t`Contractor`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
        </Container>
    )
}

export default ContractorUserAddForm;
